import Model from "./Model";

export type PatientRoundState = "scheduled" | "open" | "expired" | "completed";

/** One unlock wave of a survey's patient questions. */
export default class PatientRound extends Model {
  static type = "patient_rounds";

  offsetDays: number;
  unlockAt: string;
  expiresAt: string;
  sentAt: string | null;
  openedAt: string | null;
  completedAt: string | null;
  state: PatientRoundState;
  // The message carrying this wave's link, null until scheduled.
  delivery: {
    status: string;
    sentAt: string | null;
    deliveredAt: string | null;
    readAt: string | null;
    failedAt: string | null;
    errorMessage: string | null;
  } | null;
}
